import apis from '@/api/system.announce'

const listConfig = [
    { title: '公共标题', key: 'title' },
    { title: '公共时间', key: 'time' },
]

const btnConfig = [
    { bg: '#19458C', title: '新 增', key: 'add', role: 'ADD' },
    { bg: '#19458C', title: '编 辑', key: 'update', role: 'Edit' },
    { bg: '#EA5B24', title: '删 除', key: 'delete', role: 'Del' },
]

function fromConfig() {
    return [
        { title: '标题', value: '', key: 'title', type: 'input' },
        { title: '内容', value: '', key: 'content', type: 'wangeditor', span: 24, id: 'wangeditor1' },
    ]
}

export default function config() {
    return {
        listConfig,
        btnConfig,
        fromConfig,
        apis
    }
}
